import { useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { MdOutlineClose, MdLabel, MdScore, MdBusinessCenter } from "react-icons/md";
import { Button } from "../../components/ui";
// import { listSubEntities } from "../api/subEntity";

export default function RuleModal({ open, onClose, initial, account_id }) {
  const [label, setLabel] = useState("");
  const [score, setScore] = useState(0);
  const [subEntityId, setSubEntityId] = useState(null);
  // const [subEntities, setSubEntities] = useState([]);

  useEffect(() => {
    setLabel(initial?.label ?? "");
    setScore(initial?.score ?? 0);
    setSubEntityId(initial?.sub_entity_id ?? null);
  }, [initial]);

  // Update useEffect to fetch sub-entities for the specific entity
  // useEffect(() => {
  //   if (account_id) {
  //     listSubEntities(account_id)
  //       .then(setSubEntities)
  //       .catch(error => {
  //         console.error("Error fetching sub-entities:", error);
  //         setSubEntities([]);
  //       });
  //   }
  // }, [account_id]); 

  const handleSave = () => {
    onClose({
      label,
      score,
      sub_entity_id: subEntityId,
      account_id,
    });
  };

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => onClose(null)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gradient-to-br from-blue-500/20 to-purple-500/20 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95 translate-y-4"
              enterTo="opacity-100 scale-100 translate-y-0"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100 translate-y-0"
              leaveTo="opacity-0 scale-95 translate-y-4"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 shadow-xl transition-all border border-gray-200">
                <div className="flex items-center justify-between mb-8">
                  <Dialog.Title className="text-xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    {initial ? "✨ Edit Rule" : "✨ New Rule"}
                  </Dialog.Title>
                  <button
                    onClick={() => onClose(null)}
                    className="text-gray-400 hover:text-gray-500 transition-all hover:rotate-90 duration-300"
                  >
                    <MdOutlineClose size={22} />
                  </button>
                </div>

                <div className="space-y-6">
                  {/* Rule Label Input */}
                  <div className="group">
                    <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                      <MdLabel className="text-blue-500" size={18} />
                      Rule Label
                    </label>
                    <input
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg shadow-sm 
                        focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all
                        group-hover:border-blue-400"
                      placeholder="Enter a descriptive label..."
                      value={label}
                      onChange={(e) => setLabel(e.target.value)}
                    />
                  </div>

                  {/* Score Input */}
                  <div className="group">
                    <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                      <MdScore className="text-purple-500" size={18} />
                      Score
                    </label>
                    <input
                      type="number"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg shadow-sm 
                        focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 transition-all
                        group-hover:border-purple-400"
                      placeholder="Enter score value..."
                      value={score}
                      onChange={(e) => setScore(Number(e.target.value))}
                    />
                  </div>

                  {/* Sub-Entity Select */}
                  {/* <div className="group">
                    <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                      <MdBusinessCenter className="text-indigo-500" size={18} />
                      Sub-Entity
                    </label>
                    <select
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg shadow-sm 
                        focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all
                        group-hover:border-indigo-400"
                      value={subEntityId ?? ""}
                      onChange={(e) => setSubEntityId(Number(e.target.value))}
                    >
                      <option value="">— Select Sub-Entity (Optional) —</option>
                      {subEntities.map((se) => (
                        <option key={se.id} value={se.id}>
                          {se.name}
                        </option>
                      ))}
                    </select>
                  </div> */}
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end gap-3 mt-8">
                  <Button
                    variant="secondary"
                    size="lg"
                    onClick={() => onClose(null)}
                  >
                    Cancel
                  </Button>
                  <Button
                    size="lg"
                    onClick={handleSave}
                  >
                    {initial ? "Save Changes" : "Create Rule"}
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}